// extracted by mini-css-extract-plugin
module.exports = {"ADGMCheckboxContainer":"classes_ADGMCheckboxContainer__39VER","ADGMCheckboxButton":"classes_ADGMCheckboxButton__6rpmZ","textPosition":"classes_textPosition__3Ua3s"};